module.exports = __webpack_public_path__ + "img/Picture11.f28d2b98.png";